var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.06,14.14l1.88,.67c-1.19,3.36-4.38,5.62-7.94,5.62-2.31,0-4.45-.96-6-2.54v2.11h-2v-6h6v2h-3.02c1.2,1.5,3.03,2.43,5.02,2.43,2.71,0,5.15-1.72,6.06-4.29Zm-.06-10.14v2.11c-1.55-1.58-3.69-2.54-6-2.54-3.56,0-6.75,2.26-7.94,5.62l1.88,.67c.91-2.56,3.34-4.29,6.06-4.29,1.99,0,3.82,.93,5.02,2.43h-3.02v2h6V4h-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/1782902422/media/icon-refresh.a08db7d5e69ceb0ed1b79c9a8979fe65.svg";
export { ForwardRef as ReactComponent };